import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import AuthProvider from './Context/AuthContext';
import { ChakraProvider } from "@chakra-ui/react"


ReactDOM.render(<ChakraProvider resetCSS={false}><AuthProvider><App /></AuthProvider></ChakraProvider>, document.getElementById('root'));

